export default __webpack_public_path__ + "static/box-42b3a53ae6e82aeff26649d6731c38ed.png";